export default "__VITE_ASSET__8vGXc0zz__"